import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import AboutPage from './pages/AboutPage';
import TeamsPage from './pages/TeamsPage';
import EngineeringTeamPage from './pages/EngineeringTeamPage';
import ResearchTeamPage from './pages/ResearchTeamPage';
import VolunteeringTeamPage from './pages/VolunteeringTeamPage';
import GetInvolvedPage from './pages/GetInvolvedPage';
import ContactPage from './pages/ContactPage';
import EventsPage from './pages/EventsPage';
import NewsletterArchivePage from './pages/NewsletterArchivePage';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/teams" element={<TeamsPage />} />
            <Route path="/teams/engineering" element={<EngineeringTeamPage />} />
            <Route path="/teams/research" element={<ResearchTeamPage />} />
            <Route path="/teams/volunteering" element={<VolunteeringTeamPage />} />
            <Route path="/get-involved" element={<GetInvolvedPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/newsletter-archive" element={<NewsletterArchivePage />} />
          </Routes>
          <Footer />
          <ScrollToTop />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
